import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/ocean-smart-electrical-panel-40';
import { useGlobal } from '@/utils/useGlobal';
import Support from '@elem/compPage/OceanSmartElectricalPanel40/Support';
import dynamic from 'next/dynamic';

export default function Page({ SEO }: any) {
    const { useRouter, useEffect, useLang } = useGlobal();

    const { t } = useLang('SHP40');

    const router = useRouter();

    const { locale } = router;

    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });

    useEffect(() => {
        if (!seoconfig.include.includes(locale)) {
            router.push('/404');
        }
    }, []);

    return (
        <PageLayout isNoFixed hideToTop theme="black">
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url + '/support'} />
            <GtmPageLoad />
            <Support />
        </PageLayout>
    );
}
